import { Products } from "../../../types/Product";

import ProductCard from "../ProductCard2";
import Button from "@mui/material/Button";

import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

//import styles from './ProductList.module.css';
import "./ProductList.module.css";
import "../ProductCard/hasan.css"; //ProductList.module.css";

interface Props {
  products: Products;
  handle_AddOneToCart: any;
  handle_RemoveOneFromCart: any;
  isPr3: boolean;
  URL_API:any;
  Pagination: any;
}
/*
    <div
      className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-4"
      data-test="product-list-container"
    >
      <div
        className="border border-gray-200 font-lato"
        data-test="product-card"
      >
      </div>

 */

const ProductList = (props: Props) => {
  let {
    products,
    handle_AddOneToCart,
    handle_RemoveOneFromCart,
    isPr3,
    URL_API,
    Pagination,
  } = props;

  let {
    InCartOn,
    page,
    numberOfPages,
    onPageChange,
    label,
    numberOfItemsPerPage,
  } = Pagination;

  let numallproducts = products.length;
  let numproducts = numberOfItemsPerPage * (page + 1);
  if (numproducts > numallproducts) numproducts = numallproducts;
  if (!InCartOn)
    products = products.slice(0, numberOfItemsPerPage * (page + 1));

  return (
    <>
      <div className="product-list">
        {products.map((product) => (
          <ProductCard
            product={product}
            handle_AddOneToCart={handle_AddOneToCart}
            handle_RemoveOneFromCart={handle_RemoveOneFromCart}
            key={product._id}
            isPr3={isPr3}
            URL_API={URL_API}
          />
        ))}
      </div>
      {InCartOn === true ? (
        <>
          <div className="d-flex justify-content-center text-center mt-4">
            <div className="page-item">Весь товар в корзине</div>
            <br />
            <br />
          </div>
        </>
      ) : (
        <>
          <div className="d-flex justify-content-center text-center">
            <div className="fs-5">
              <span className="price fw-bold">
                {numproducts} из {numallproducts} товаров
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-center text-center">
            <div>
              <Button
                size="small"
                //                        component={Link}
                color="primary"
                variant={"contained"} // : "outlined"
                sx={{
                  height: 40,
                  marginLeft: 2,
                  marginTop: 1,
                  display: "inline-flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  onPageChange(page + 1);
                }}
              >
                Більше товарів
              </Button>
            </div>
          </div>

          <div className="d-flex justify-content-center text-center">
            <div>
              <div
                className="catalog-page-list-wrap"
                style={{
                  position: "relative",
                  margin: "16px 0 0 0",
                }}
              >
                <ul className="pagination">
                  <li className="page-item">
                    <a
                      rel="prev"
                      role="button"
                      className="page-link"
                      tabIndex={0}
                      aria-label="Page 1"
                      aria-current="page"
                    >
                      1
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      //role="button"
                      //className="page-link"
                      //tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      ...
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      role="button"
                      className="page-link"
                      tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      4
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      role="button"
                      className="page-link   active"
                      tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      5
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      role="button"
                      className="page-link"
                      tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      6
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      //role="button"
                      //className="page-link"
                      //tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      ...
                    </a>
                  </li>
                  <li className="page-item">
                    <a
                      rel="canonical"
                      role="button"
                      className="page-link"
                      tabIndex={-1}
                      aria-label="Page 2 is your current page"
                    >
                      {numberOfPages}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
      {/*
      <div className="d-flex justify-content-center text-center mt-4">
        <div className="pagination-box">
          <ul className="pagination">
            <li className="page-item">
              <a
                className="page-link disabled"
                tabIndex={0}
                role="button"
                aria-disabled="false"
                aria-label="Previous page"
                rel="prev"
              >
                &lt; previous
              </a>
            </li>
            <li className="page-item  active">
              <a
                rel="prev"
                role="button"
                className="page-link"
                tabIndex={0}
                aria-label="Page 1"
                aria-current="page"
              >
                1
              </a>
            </li>
            <li className="page-item">
              <a
                rel="canonical"
                role="button"
                className="page-link"
                tabIndex={-1}
                aria-label="Page 2 is your current page"
              >
                2
              </a>
            </li>
            <li className="page-item">
              <a
                className="page-link "
                tabIndex={-1}
                role="button"
                aria-disabled="true"
                aria-label="Next page"
                rel="next"
                onClick={() => {
                  onPageChange(page + 1);
                }}
              >
                next &gt;
              </a>
            </li>
          </ul>
        </div>
      </div>
*/}
    </>
  );
};

export default ProductList;
